import { DEFAULT_CONDITIONAL_FEATURE_FILTER } from 'constants/common'
import ConditionalFeatureType from 'store/actionTypes/conditionalFeature'

const initialData = {
  list: [],
  pagination: {},
  filer: DEFAULT_CONDITIONAL_FEATURE_FILTER
}

const conditionalFeature = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ConditionalFeatureType.GET_CONDITIONAL_FEATURE_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    default:
      return state
  }
}

export default conditionalFeature
